import { useCallback } from 'react';

export const useWhatsappApi = ({
  phone,
  text,
}: {
  phone: string;
  text: string;
}) => {
  const handleSendWhatsappMessage = useCallback(() => {
    window.open(
      `https://api.whatsapp.com/send/?phone=${phone}&text=${text}`,
      '_blank',
      'noopener',
    );
  }, [phone, text]);

  return { handleSendWhatsappMessage };
};
